export const NoSegmentSelectedMessage = 'No segment selected';
export const SelectSegmentMessage = 'Please select a segment from the dropdown above';
export const NoMatchingSegmentsMessage = 'No matching segments';
export const CheckFiltersMessage = 'Please check your filters and try again';
